// MON-505: formatGeofences decora o item da lista com creatorName/creatorEmail so para exibicao.
// O merge de update ({...geofences[index], ...data}) reenvia isso pra API, que nao conhece esses
// campos (org.traccar.model.Geofence) e devolve 400 Unrecognized field.
export const cleanupForUpdate = (geofence) => {
    const clean = {...geofence};
    delete clean.creatorName;
    delete clean.creatorEmail;
    delete clean.createdAtFormatted;
    delete clean.updatedAtFormatted;
    return clean;
};
